import { type ObservedAttribute, html } from "../lib/utils.ts"
import "iconify-icon"
import { getElement } from "../lib/get-elements.ts"
import { WithAttributeProps, string } from "../mixins/with-attributes-props.ts"

const template = html`
  <style>
    :host[hidden] {
      display: none;
    }
    :host {
      display: inline-block;
    }
    .loader {
      display: block;
      animation: spin 2s linear infinite;
      color: inherit;
    }
    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
    @media (prefers-reduced-motion: reduce) {
      .loader {
        animation: none;
      }
    }
  </style>
  <iconify-icon class="loader" icon="tabler:loader" inline></iconify-icon>`

export class HTMLLoaderElement extends WithAttributeProps(HTMLElement, {
	size: string(),
}) {
	#shadowRoot
	#iconElement: HTMLElement

	constructor() {
		super()
		this.#shadowRoot = this.attachShadow({ mode: "closed" })
		this.#shadowRoot.appendChild(template.content.cloneNode(true))
		this.#iconElement = getElement("iconify-icon", this.#shadowRoot)
		this.#updateSize()
	}

	static observedAttributes = ["size"] as const
	attributeChangedCallback(name: ObservedAttribute<typeof HTMLLoaderElement>) {
		switch (name) {
			case "size":
				this.#updateSize()
				break
		}
	}

	#updateSize() {
		const size = this.size
		if (size == null) {
			this.#iconElement.removeAttribute("width")
			this.#iconElement.removeAttribute("height")
			return
		}
		this.#iconElement.setAttribute("width", size)
		this.#iconElement.setAttribute("height", size)
	}
}

customElements.define("x-loader", HTMLLoaderElement)
